export default __webpack_public_path__ + "static/media/toggle-off-icon.62b01ec3.svg";